import { render, staticRenderFns } from "./bjDialog.vue?vue&type=template&id=74d18f1f"
import script from "./bjDialog.vue?vue&type=script&lang=js"
export * from "./bjDialog.vue?vue&type=script&lang=js"
import style0 from "./bjDialog.vue?vue&type=style&index=0&id=74d18f1f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports